import type { DefaultInputStateProps } from './invest-states'

export const isApprovalRequire = (inputState: DefaultInputStateProps) => {
  // const isSavingsVault =
  // inputState.inputCurrency.type === 'savings-vault' ||
  // inputState.outputCurrency.type === 'savings-vault'
  // return !isSavingsVault && inputState.allowance.lt(inputState.sellAmount)
  return inputState.allowance.lt(inputState.sellAmount)
}
